/* unplugin-vue-components disabled */import script from "./PracticeItem.vue?vue&type=script&setup=true&name=PracticeItem&lang=js"
export * from "./PracticeItem.vue?vue&type=script&setup=true&name=PracticeItem&lang=js"

import "./PracticeItem.vue?vue&type=style&index=0&id=1a92ca35&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a92ca35"]])

export default __exports__